export class UserRole {
    constructor(
        public id: number,
        public title: string,
        public created_at: Date,
        public updated_at: Date
    ) {}

  }